import React, { useEffect, useState } from 'react';
import { checkAssessmentIsV2 } from './api/checkAssessmentIsV2';
import { useParams } from 'react-router-dom';
import AssessmentResultsViewer from './AssessmentResultsViewer';
import LoadingState from '../../components/LoadingState';
import { logger } from '../../utils/logger';

// TODO: once we no longer support V1 assessments, we can route directly to the AssessmentResultsViewer
export const AssessmentResultsViewerRouter = ({ V1ResultsViewer }: { V1ResultsViewer: React.ComponentType }) => {
  const { assessmentId } = useParams<{ assessmentId: string }>();
  const [isV2, setIsV2] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAssessmentIsV2(assessmentId)
      .then(response => {
        setIsV2(response.isV2);
        setIsLoading(false);
      })
      .catch(error => {
        logger.error(error);
        setIsLoading(false);
      });
  }, [assessmentId]);

  if (isLoading) {
    return <LoadingState />;
  }

  return isV2 ? <AssessmentResultsViewer /> : <V1ResultsViewer />;
};
